<template>
	<div class="register-page">
		<div class="register-container">
			<div class="register-content">
				<h3 class="register-title">新用户注册</h3>
				<div class="register-form">
					<div class="reg-input-group">
						<input type="text" placeholder="请输入手机号" v-model="registerForm.phone">
					</div>
					<div class="reg-input-group">
						<input type="text" placeholder="请输入验证码" v-model="registerForm.code">
						<span class="get-verify-code" @click="sendVerifyCode"
							:style="{ cursor: isSending ? 'not-allowed' : 'pointer', color: isSending ? '#999' : '#FE8E04' }">{{ codeText }}</span>
					</div>
					<div class="reg-input-group">
						<input :type="showPassword ? 'text' : 'password'" placeholder="请设置6-12位密码"
							v-model="registerForm.password">
						<span class="toggle-pwd" @click="showPassword = !showPassword">
							<svg v-if="!showPassword" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor"
								stroke-width="2" fill="none">
								<path
									d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
								</path>
								<line x1="1" y1="1" x2="23" y2="23"></line>
							</svg>
							<svg v-else viewBox="0 0 24 24" width="16" height="16" stroke="currentColor"
								stroke-width="2" fill="none">
								<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
								<circle cx="12" cy="12" r="3"></circle>
							</svg>
						</span>
					</div>
					<div class="reg-input-group">
						<input :type="showConfirmPassword ? 'text' : 'password'" placeholder="请再次确认密码"
							v-model="registerForm.confirmPassword">
						<span class="toggle-pwd" @click="showConfirmPassword = !showConfirmPassword">
							<svg v-if="!showConfirmPassword" viewBox="0 0 24 24" width="16" height="16"
								stroke="currentColor" stroke-width="2" fill="none">
								<path
									d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
								</path>
								<line x1="1" y1="1" x2="23" y2="23"></line>
							</svg>
							<svg v-else viewBox="0 0 24 24" width="16" height="16" stroke="currentColor"
								stroke-width="2" fill="none">
								<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
								<circle cx="12" cy="12" r="3"></circle>
							</svg>
						</span>
					</div>

					<div class="reg-agreement">
						<label>
							<input type="checkbox" v-model="registerForm.agreement">
							<span>阅读并勾选
								<span class="reg-link" @click.stop.prevent="goToAgreement">《用户协议》</span>和
								<span class="reg-link" @click.stop.prevent="goToPrivacy">《隐私政策》</span>
							</span>
						</label>
					</div>

					<button class="next-step-btn" @click="handleRegister">下一步</button>

					<div class="go-login">
						<span @click="goToLogin">已有账号？去登录</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		sendCode,
		register,
		login
	} from '@/api/user'
	import eventBus from '@/utils/eventBus'
	import { ElMessage } from 'element-plus'
	import 'element-plus/es/components/message/style/css'

	export default {
		name: 'RegisterView',
		data() {
			return {
				registerForm: {
					phone: '',
					code: '',
					password: '',
					confirmPassword: '',
					agreement: false
				},
				pcOpenid: this.$route.query.pcOpenid || '',
				unionid: this.$route.query.unionid || '',
				showPassword: false,
				showConfirmPassword: false,
				codeText: '验证码',
				isSending: false,
				timer: null
			}
		},
		methods: {
			goToLogin() {
				this.$router.push('/');
			},
			goToAgreement() {
				this.$router.push('/agreement');
			},
			goToPrivacy() {
				this.$router.push('/privacy');
			},
			async handleRegister() {
				const {
					phone,
					code,
					password,
					confirmPassword,
					agreement
				} = this.registerForm;

				if (!phone) {
					ElMessage.warning('请输入手机号');
					return;
				}
				if (!/^1[3-9]\d{9}$/.test(phone)) {
					ElMessage.warning('请输入正确的手机号');
					return;
				}
				if (!code) {
					ElMessage.warning('请输入验证码');
					return;
				}
				if (!password) {
					ElMessage.warning('请输入密码');
					return;
				}
				if (password.length < 6 || password.length > 12) {
					ElMessage.warning('密码长度请在6-12位之间');
					return;
				}
				if (password !== confirmPassword) {
					ElMessage.warning('两次输入的密码不一致');
					return;
				}
				if (!agreement) {
					ElMessage.warning('请阅读并勾选协议');
					return;
				}

				try {
					await register({
						phone,
						password,
						code,
						pcOpenid: this.pcOpenid,
						unionid: this.unionid
					});
					// 微信扫码注册：注册成功后直接登录并保存 token
					const isWechatRegister = !!(this.pcOpenid || this.unionid);
					if (isWechatRegister) {
						const res = await login({ phone, password });
						if (res && res.token) {
							localStorage.setItem('token', res.token);
							if (res.userInfo) {
								localStorage.setItem('userInfo', JSON.stringify(res.userInfo));
							}
							if (eventBus && eventBus.emit) {
								eventBus.emit('login-success');
							}
							ElMessage.success('注册成功，已自动登录');
							this.$router.replace('/');
							return;
						}
					}
					ElMessage.success('注册成功');
					this.goToLogin();
				} catch (error) {
					ElMessage.error(error.message || '注册失败');
				}
			},
			async sendVerifyCode() {
				if (this.isSending) return;

				const phone = this.registerForm.phone;
				if (!phone) {
					ElMessage.warning('请输入手机号');
					return;
				}
				if (!/^1[3-9]\d{9}$/.test(phone)) {
					ElMessage.warning('请输入正确的手机号');
					return;
				}

				this.isSending = true;
				try {
					await sendCode({
						phone: phone,
						type: 2
					}); // type 2 might be for register

					// Start countdown
					let count = 60;
					this.codeText = `${count}s`;
					this.timer = setInterval(() => {
						count--;
						if (count > 0) {
							this.codeText = `${count}s`;
						} else {
							this.stopTimer();
						}
					}, 1000);

				} catch (error) {
					this.isSending = false;
					ElMessage.error(error.message || '发送验证码失败');
				}
			},
			stopTimer() {
				if (this.timer) {
					clearInterval(this.timer);
					this.timer = null;
				}
				this.isSending = false;
				this.codeText = '验证码';
			}
		},
		beforeUnmount() {
			this.stopTimer();
		}
	}
</script>

<style scoped>
	.register-page {
		width: 100%;
		min-height: calc(100vh - 60px);
		/* Subtract header height if header is present */
		/* background-color: #1a1a1a; /* Dark background for the whole page area */
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.register-container {
		width: 800px;
		background-color: #1a1a1a;
		/* Matches page background or slightly different? Screenshot looks consistent */
		color: #fff;
		border-radius: 4px;
		padding: 40px 0;
		/* box-shadow: 0 4px 12px rgba(0,0,0,0.3); Optional shadow if background differs */
	}

	.register-content {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.register-title {
		font-size: 24px;
		font-weight: bold;
		color: #fff;
		margin-bottom: 40px;
	}

	.register-form {
		width: 400px;
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.reg-input-group {
		position: relative;
		border-bottom: 1px solid #333;
	}

	.reg-input-group input {
		width: 100%;
		background: transparent;
		border: none;
		padding: 15px 0;
		color: #fff;
		font-size: 14px;
		outline: none;
	}

	.reg-input-group input::placeholder {
		color: #666;
	}

	.get-verify-code {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		color: #FE8E04;
		cursor: pointer;
		font-size: 14px;
		user-select: none;
	}

	.toggle-pwd {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
		width: 20px;
		height: 20px;
		color: #999;
	}

	.reg-agreement {
		margin-top: 10px;
		font-size: 12px;
		color: #666;
		display: flex;
		align-items: center;
	}

	.reg-agreement label {
		display: flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
	}

	.reg-agreement input[type="checkbox"] {
		accent-color: #FE8E04;
	}

	.reg-agreement span {
		color: #999;
	}

	.reg-agreement .reg-link {
		color: #FE8E04;
		text-decoration: none;
		cursor: pointer;
	}
	.reg-agreement .reg-link:hover {
		text-decoration: underline;
	}

	.next-step-btn {
		width: 100%;
		padding: 12px;
		background-color: #FE8E04;
		color: #fff;
		border: none;
		border-radius: 25px;
		font-size: 16px;
		margin-top: 20px;
		cursor: pointer;
	}

	.next-step-btn:hover {
		background-color: #e68a00;
	}

	.go-login {
		text-align: center;
		margin-top: 20px;
		font-size: 14px;
		color: #FE8E04;
		cursor: pointer;
	}

	.go-login span:hover {
		text-decoration: underline;
	}
</style>